import { combineReducers } from 'redux';
import authReducer from './auth.reducer';
import brandReducer from './brand.reducer';
import campaignReducer from './campaign.reducer';
import cartReducer from './cart.reducer';
import configReducer from './config.reducer';
import flashMessages from './flashMessages.reducer';
import offerReducer from './offer.reducer';

export const rootReducer = combineReducers({
  config: configReducer,
  auth: authReducer,
  flashMessages,
  offer: offerReducer,
  brand: brandReducer,
  campaign: campaignReducer,
  cart: cartReducer,
});
